module.exports = __webpack_public_path__ + "media/components/country-flag/static/fk-a94f25ed6ccca91ea93500c2cd40263c.svg";